/*!
 * All material copyright ESRI, All Rights Reserved, unless otherwise specified.
 * See https://github.com/Esri/calcite-design-system/blob/dev/LICENSE.md for details.
 * v2.10.1
 */
import { I as Icon, d as defineCustomElement$1 } from './icon.js';

const CalciteIcon = Icon;
const defineCustomElement = defineCustomElement$1;

export { CalciteIcon, defineCustomElement };

//# sourceMappingURL=calcite-icon.js.map